export default __webpack_public_path__ + "static/media/h5-section1-bg1.5582bc13.png";